import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";

// The catalog is served straight from bps-go now: it pages by page number and
// answers { total, items }. useData is shared by every list page and reads
// count and data, so the translation belongs here rather than in that hook.
export const GetSellSpecialtyItems = async ({
  page = 1,
  perPage = DEFAULT_LIMIT,
  name = "",
  isActive = null,
}) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });

  if (name) {
    params.append("name", name);
  }

  // Only sent when a status filter is chosen; false is the Inactive filter.
  if (isActive !== null) {
    params.append("is_active", String(isActive));
  }

  const response = await fetchApi(
    `card-issuing/specialty-items?${params}`,
    options
  );

  return {
    count: response?.total ?? 0,
    data: response?.items ?? [],
    limit: perPage,
    offset: response?.offset ?? (page - 1) * perPage,
  };
};
